
define('tmpl!core/templates/webidl/dictionary.html', ['deps/handlebars'], function (hb) { return hb.compile('<span class=\'idlDictionary\' id=\'idl-def-{{obj.refId}}\'>{{extAttr obj indent true\n}}{{idn indent}}{{partial}}dictionary <span class=\'idlDictionaryID\'>{{obj.id}}</span>{{superclasses obj}} &#123;\n{{{children}}}&#125;;</span>\n');});

